import { Badge, Spinner } from "../../../shared";
import { capitalizeFirstLetter } from "../../../utils";
import {
  formatUserDate,
  getUserPlatformLabel,
  getUserStatusMeta,
} from "./user.utils";
import { DetailField } from "./DetailField";

/** Read-only account metadata for Settings → Users → Show. */
export const AccountOverview = ({ user = {}, loading = false }) => {
  const statusMeta = getUserStatusMeta(user);
  const platformLabel = getUserPlatformLabel(user);

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200">
      <div className="border-b border-gray-200 bg-gray-50 p-4">
        <div className="font-semibold text-gray-900">Account overview</div>
        <p className="text-xs text-gray-500">
          Sign-in email, account status, and workspace metadata.
        </p>
      </div>
      <div className="bg-white p-4">
        {loading ? (
          <div className="flex justify-center py-6">
            <Spinner />
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <DetailField label="Email" value={user.email || "—"} />
            <DetailField label="Status">
              <Badge color={statusMeta.color} label={statusMeta.label} />
            </DetailField>
            <DetailField
              label="Account type"
              value={capitalizeFirstLetter(user.type || user.role || "—")}
            />
            <DetailField label="Platform access" value={platformLabel} />
            <DetailField
              label="Date added"
              value={formatUserDate(user.dateCreated || user.createdAt)}
            />
            <DetailField
              label="Last updated"
              value={formatUserDate(user.dateUpdated || user.updatedAt)}
            />
            <DetailField
              label="Organization"
              value={user.organization?.name || "—"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountOverview;
